const DemoQuestions = [
    {
        "id": "Demo1",
        "imageUrl": "",
        "explanations": [
            {
                "text": "大阪は日本の首都ではありません。",
                "displayText": "<ruby>大阪<rt>おおさか</rt></ruby>は<ruby>日本<rt>にっぽん</rt></ruby>の<ruby>首都<rt>しゅと</rt></ruby>ではありません。"
            },
            {
                "text": "京都は歴史的な首都でしたが、現在は違います。",
                "displayText": "<ruby>京都<rt>きょうと</rt></ruby>は<ruby>歴史的<rt>れきしてき</rt></ruby>な<ruby>首都<rt>しゅと</rt></ruby>でしたが、<ruby>現在<rt>げんざい</rt></ruby>は<ruby>違<rt>ちが</rt></ruby>います。"
            },
            {
                "text": "東京は現在の日本の首都です。",
                "displayText": "<ruby>東京<rt>とうきょう</rt></ruby>は<ruby>現在<rt>げんざい</rt></ruby>の<ruby>日本<rt>にっぽん</rt></ruby>の<ruby>首都<rt>しゅと</rt></ruby>です。"
            },
            {
                "text": "札幌は北海道の都市で、首都ではありません。",
                "displayText": "<ruby>札幌<rt>さっぽろ</rt></ruby>は<ruby>北海道<rt>ほっかいどう</rt></ruby>の<ruby>都市<rt>とし</rt></ruby>で、<ruby>首都<rt>しゅと</rt></ruby>ではありません。"
            }
        ],
        "options": [
            {
                "option_id":1,
                "text":"大阪",
                "displayText":"<ruby>大阪<rt>おおさか</rt></ruby>",
                "isCorrect":false
            },
            {
                "option_id":2,
                "text":"京都",
                "displayText":"<ruby>京都<rt>きょうと</rt></ruby>",
                "isCorrect":false
            },
            {
                "option_id":3,
                "text":"東京",
                "displayText":"<ruby>東京<rt>とうきょう</rt></ruby>",
                "isCorrect":true
            },
            {
                "option_id":4,
                "text":"札幌",
                "displayText":"<ruby>札幌<rt>さっぽろ</rt></ruby>",
                "isCorrect":false
            },
        ],
        "displayQuestion":"<div><ruby>日本<rt>にっぽん</rt></ruby>の<ruby>首都<rt>しゅと</rt></ruby>はどこですか？</div>",
        "question": "日本の首都はどこですか？"
    },{
        "answer": "静岡県と山梨県",
        "id": "Demo2",
        "imageUrl": "",
        "displayQuestion":"<div><ruby>富士山<rt>ふじさん</rt></ruby>はどの<ruby>県<rt>けん</rt></ruby>にありますか？</div>",
        "options": [
            {
                "option_id": 1,
                "text": "長野県",
                "displayText":"<ruby>長野<rt>ながの</rt></ruby><ruby>県<rt>けん</rt></ruby>",
                "isCorrect":false
            },
            {
                "option_id": 2,
                "text": "静岡県と山梨県",
                "displayText":"<ruby>静岡<rt>しずおか</rt></ruby><ruby>県<rt>けん</rt></ruby>と<ruby>山梨<rt>やまなし</rt></ruby><ruby>県<rt>けん</rt></ruby>",
                "isCorrect":true
            },
            {
                "option_id": 3,
                "text": "神奈川県",
                "displayText":"<ruby>神奈川<rt>かながわ</rt></ruby><ruby>県<rt>けん</rt></ruby>",
                "isCorrect":false
            },
            {
                "option_id": 4,
                "text": "新潟県",
                "displayText":"<ruby>新潟<rt>にいがた</rt></ruby><ruby>県<rt>けん</rt></ruby>",
                "isCorrect":false
            }
        ],
        "explanations": [
            {
                "text": "長野県には富士山はありません。",
                "displayText": "<ruby>長野<rt>ながの</rt></ruby><ruby>県<rt>けん</rt></ruby>には<ruby>富士山<rt>ふじさん</rt></ruby>はありません。"
            },
            {
                "text": "富士山は静岡県と山梨県にまたがっています。",
                "displayText": "<ruby>富士山<rt>ふじさん</rt></ruby>は<ruby>静岡<rt>しずおか</rt></ruby><ruby>県<rt>けん</rt></ruby>と<ruby>山梨<rt>やまなし</rt></ruby><ruby>県<rt>けん</rt></ruby>にまたがっています。"
            },
            {
                "text": "神奈川県は富士山がある県ではありません。",
                "displayText": "<ruby>神奈川<rt>かながわ</rt></ruby><ruby>県<rt>けん</rt></ruby>は<ruby>富士山<rt>ふじさん</rt></ruby>がある<ruby>県<rt>けん</rt></ruby>ではありません。"
            },
            {
                "text": "新潟県には富士山はありません。",
                "displayText": "<ruby>新潟<rt>にいがた</rt></ruby><ruby>県<rt>けん</rt></ruby>には<ruby>富士山<rt>ふじさん</rt></ruby>はありません。"
            }
        ],
        "question": "富士山はどの県にありますか？"
    },
];

export default DemoQuestions;